import { render, staticRenderFns } from "./EpgCard.vue?vue&type=template&id=ea3a3390"
import script from "./EpgCard.vue?vue&type=script&lang=ts"
export * from "./EpgCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports